import axios from 'axios'
import uuidv4 from 'uuid/v4'

export const state = {
  comments: [],
}

export const getters = {
  getComment(state) {
    return state.comments
  },
}

export const mutations = {
  SET_MODULES(state, newValue) {
    state.modules = newValue
  },
  SET_COMMENTS(state, newValue) {
    state.comments = newValue
  },
}

export const actions = {
  // saveUserRole({ commit, state }, { id, rev, name, currentRole, groupId }) {
  //   let userRoleDocument
  //   if (id === null && rev === null) {
  //     userRoleDocument = {
  //       _id: 'role_' + uuidv4(),
  //       name: name,
  //       type: 'role',
  //       groupId: groupId,
  //       module: currentRole,
  //     }
  //   } else {
  //     userRoleDocument = {
  //       _id: id,
  //       _rev: rev,
  //       name: name,
  //       type: 'role',
  //       groupId: groupId,
  //       module: currentRole,
  //     }
  //   }
  //   return axios.post(`v1/userRoles/`, userRoleDocument).then(response => {
  //     return response.data
  //   })
  // },
  getComments({ commit, state }, { groupId, outlets }) {
    let params = {
      group_id: groupId,
      outlets: outlets,
    }
    return axios.get(`v1/comments/`, { params: params }).then(response => {
      commit('SET_COMMENTS', response.data)
      return response.data
    })
  },
  saveComment({ commit, state }, { comObject }) {
    return axios.post(`v1/comments/`, comObject).then(response => {
      return response.data
    })
  },
  updateComment({ commit, state }, { comObject }) {
    return axios.put(`v1/comments/`, comObject).then(response => {
      return response.data
    })
  },
  // getUserRoles({ commit, state }, { groupId }) {
  //   return axios.get(`v1/userRoles/${groupId}`).then(response => {
  //     commit('SET_GROUP_USER_ROLES', response.data.docs)
  //     return response.data.docs
  //   })
  // },
  // deleteUserDocument(
  //   { commit, state },
  //   { documentId: userDocumentId, rev: userDocumentRev }
  // ) {
  //   return axios
  //     .delete(`/v1/users/${userDocumentId}/${userDocumentRev}`)
  //     .then(response => {
  //       return response.data
  //     })
  // },
  // deleteUserRoleDocument(
  //   { commit, state },
  //   { documentId: userRoleDocumentId, rev: userRoleDocumentRev }
  // ) {
  //   return axios
  //     .delete(`/v1/userRoles/${userRoleDocumentId}/${userRoleDocumentRev}`)
  //     .then(response => {
  //       return response.data
  //     })
  // },
}
